export const selectFiltersConfig = {
  country: {
    type: 'select',
    label: 'Country',
    placeholder: (t) => `${t('Filter by')} ${t('Country').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    options: [],
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  // administrativeLevel1: {
  //   type: 'select',
  //   label: 'Admin Level 01',
  //   placeholder: (t) => `${t('Filter by')} ${t('Admin Level 01').toLowerCase()}`,
  //   style: { flex: 1 },
  //   labelStyle: { flex: 1 },
  //   options: [],
  //   getLabel: (option) => option.label,
  //   getValue: (option) => option.value,
  // },
  // administrativeLevel2: {
  //   type: 'select',
  //   label: 'Admin Level 02',
  //   placeholder: (t) => `${t('Filter by')} ${t('Admin Level 02').toLowerCase()}`,
  //   style: { flex: 1 },
  //   labelStyle: { flex: 1 },
  //   options: [],
  //   getLabel: (option) => option.label,
  //   getValue: (option) => option.value,
  // },
  category: {
    type: 'select',
    label: 'Location Type',
    placeholder: (t) => `${t('Filter by')} ${t('Location Type').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    options: [],
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  // dataType: {
  //   type: 'select',
  //   label: 'Data Type',
  //   placeholder: (t) => `${t('Filter by')} ${t('Data Type').toLowerCase()}`,
  //   style: { flex: 1 },
  //   labelStyle: { flex: 1 },
  //   options: [],
  //   getLabel: (option) => option.label,
  //   getValue: (option) => option.value,
  // },
};

export const filtersConfig = {
  datastakeId: '',
  name: '',
};

export const checkboxConfig = {
  datastakeId: 'ID',
  name: 'Name',
};

